import { render } from "./SecondCarouselItemColumnView.vue?vue&type=template&id=a45466a6&scoped=true"
import script from "./SecondCarouselItemColumnView.vue?vue&type=script&lang=js"
export * from "./SecondCarouselItemColumnView.vue?vue&type=script&lang=js"

import "./SecondCarouselItemColumnView.vue?vue&type=style&index=0&id=a45466a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45466a6"]])

export default __exports__